import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "col-lg-6 col-md-6 mb-4"
}
const _hoisted_8 = {
  key: 1,
  class: "col-lg-6 col-md-6 mb-4"
}
const _hoisted_9 = {
  key: 2,
  class: "col-lg-12 col-md-12 mb-4"
}
const _hoisted_10 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_13 = { class: "form-check form-switch" }
const _hoisted_14 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Payment Channel' : 'Add Payment Channel',
      subTitle: "Transactions"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Channel Type", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.channel_type) = $event)),
                required: ""
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("option", { value: "BANK" }, "Bank Transfer", -1),
                _createElementVNode("option", { value: "EWALLET" }, "E-Wallet", -1),
                _createElementVNode("option", { value: "QRIS" }, "QRIS", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.channel_type]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Provider Name (e.g. BCA, OVO)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.provider_name) = $event)),
                placeholder: "BCA",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.provider_name]
              ])
            ]),
            (_ctx.form.channel_type !== 'QRIS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Account Number", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.account_number) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.form.account_number]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.channel_type !== 'QRIS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Account Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.account_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.form.account_name]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.channel_type === 'QRIS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "QR Image", -1)),
                  (_ctx.imagePreview)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: _ctx.imagePreview,
                          alt: "QR Preview",
                          class: "img-thumbnail",
                          style: {"max-height":"200px"}
                        }, null, 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("input", {
                    class: "form-control",
                    type: "file",
                    id: "qrImage",
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleImageUpload && _ctx.handleImageUpload(...args))),
                    accept: "image/*"
                  }, null, 32)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "isActive"
                }, "Active", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_RouterLink, {
              to: "/payment-channels",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Channel' : 'Create Channel'), 1)
            ], 8, _hoisted_15)
          ])
        ], 32)
      ])
    ])
  ]))
}